import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import Fragment from "vue-fragment";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.config.productionTip = false;

//Vue-fragment
Vue.use(Fragment.Plugin);
//Toasts
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
  position: "top-left"
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
